import { useHistory } from 'react-router-dom';
import styles from './FAQSearchResultCard.module.scss';
import { Fragment } from 'react/jsx-runtime';

type FAQSearchResultCardProps = {
  category: string;
  subCategory: string;
  title: string;
  description: string;
  keyword: string;
};

const FAQSearchResultCard: React.FC<FAQSearchResultCardProps> = ({
  category,
  subCategory,
  title,
  description,
  keyword,
}) => {
  const history = useHistory();
  const refinedTitle = title.split(new RegExp(`(${keyword})`, 'gi'));
  let refinedDescription: string[] = [];
  const path = category.split(' ').join('-').toLowerCase();
  const MAX_CHARACTERS = 300;

  if (description.length <= MAX_CHARACTERS) {
    refinedDescription = description.split(new RegExp(`(${keyword})`, 'gi'));
  } else {
    const truncatedText = description.slice(0, MAX_CHARACTERS);
    const lastSpaceIndex = truncatedText.lastIndexOf(' ');
    const finalDescription =
      lastSpaceIndex >= 0 ? truncatedText.slice(0, lastSpaceIndex) + '...' : truncatedText + '...';
    refinedDescription = finalDescription.split(new RegExp(`(${keyword})`, 'gi'));
  }

  const addBrBeforeNumberWithDot = (str: string) => {
    const sentences = str.split(/\s(?=\d+\.\s)/);

    return sentences.map((sentence, index) => (
      <Fragment key={index}>
        {sentence.includes('1.') && <br />}
        {index !== 0 && <br />}
        {sentence}
      </Fragment>
    ));
  };

  return (
    <div className={styles.searchResultCard}>
      <div className={styles.searchResultCard__category}>{category}</div>
      <div onClick={() => history.push(`/category/${path}`, { category, subCategory, selectedQuestion: title })}>
        <h2 className={styles.searchResultCard__title}>
          {refinedTitle.map((word) => {
            if (word.toLowerCase() === keyword.toLowerCase()) {
              return <strong>{word}</strong>;
            }
            return <span>{word}</span>;
          })}
        </h2>
        <p className={styles.searchResultCard__description}>
          {refinedDescription.map((word) => {
            if (word.toLowerCase() === keyword.toLowerCase()) {
              return <strong>{word}</strong>;
            } else if (word.includes('*')) {
              return word.split('*').map((part, i) => {
                return (
                  <>
                    {i === 0 && part === '' && <br />}
                    {i > 0 && (
                      <>
                        <br />*
                      </>
                    )}
                    {part}
                    {i === 0 && part !== '' && <br />}
                  </>
                );
              });
            } else if (/\d+\.\s/.test(word)) {
              return addBrBeforeNumberWithDot(word);
            }
            return <span>{word}</span>;
          })}
        </p>
      </div>
    </div>
  );
};

export default FAQSearchResultCard;
